<template>
  <div class="labeled-slider">
    <InputLabel
      :input-id="sliderId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <Slider
      ref="slider"
      :value="value"
      :min="min"
      :max="max"
      :step="step"
      :disabled="disabled"
      :show-labels="showLabels"
      :show-value="showValue"
      :show-tooltip="showTooltip"
      :show-steps="showSteps"
      :height="height"
      :track-color="trackColor"
      :progress-color="progressColor"
      :thumb-color="thumbColor"
      :value-format="valueFormat"
      :min-label="minLabel"
      :max-label="maxLabel"
      v-on="$listeners"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import Slider from '../slider';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
      validator: v => v > 0
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
    showValue: {
      type: Boolean,
      default: false,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    showSteps: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '8px',
    },
    thumbSize: {
      type: String,
      default: '24px',
    },
    trackColor: {
      type: String,
      default: 'rgba(251, 146, 60, 0.3)',
    },
    progressColor: {
      type: String,
      default: '#FB923C',
    },
    thumbColor: {
      type: String,
      default: '#FB923C',
    },
    valueFormat: {
      type: Function,
      default: v => v.toString(),
    },
    minLabel: {
      type: String,
      default: null,
    },
    maxLabel: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      inputId: `slider-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, Slider },
  computed: {
    getSlider() {
      return this.$refs.slider;
    },
  },
  methods: {
    generateRandomId,
  },
};
</script>
